import { render, staticRenderFns } from "./IdeaView.vue?vue&type=template&id=0dcecd86&scoped=true&"
import script from "./IdeaView.vue?vue&type=script&lang=js&"
export * from "./IdeaView.vue?vue&type=script&lang=js&"
import style0 from "./IdeaView.vue?vue&type=style&index=0&id=0dcecd86&lang=scss&scoped=true&"
import style1 from "./IdeaView.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dcecd86",
  null
  
)

export default component.exports